

import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Path } from "./routes";
//import ProtectedRoute from "../store/ProtectedRoute";


const NotFound = lazy(() => import("../pages/404"));
const Home = lazy(() => import("../pages/home"));
const Contact = lazy(() => import("../pages/contact"));
const Events = lazy(() => import("../pages/events"));
const About = lazy(() => import("../pages/about"));



const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Home} element={<Home />} />
        <Route path={Path.Contact} element={<Contact />} />
        <Route path={Path.Events} element={<Events />} />
        <Route path={Path.About} element={<About />} />



        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;